import React from 'react';
import { TreeNodeType } from '../../../../../lib/types/types';
import { assignIdsToStruc } from '../../../../../utils/helper';
import AbschlussAenderungAnfrage from './content/AbschlussAenderungAnfrage';
import BegruendungAenderungsAnfrage, { getFormStrucBegruendungAenderungsAnfrage } from './content/BegruendungAenderungsAnfrage';

// import schemas
// import AenderungAnfrageSchema from '../../../../../lib/paths/aenderungsanfrage_FULL_Paths.json';
// const P = AenderungAnfrageSchema.attributes;

export const TreeStructureAenderungsAnfrage = () => {
	let treeNodes: TreeNodeType[] = [];

	treeNodes = [
		{
			label: 'Begründung',
			content: <BegruendungAenderungsAnfrage />,
			formStruc: getFormStrucBegruendungAenderungsAnfrage(),
		},
		{
			label: 'Abschluss',
			content: <AbschlussAenderungAnfrage />,
		},
	];

	return assignIdsToStruc(treeNodes);
};
